export enum AlarmState {
  OK = 'OK',
  ALARM = 'ALARM',
  INSUFFICIENT_DATA = 'INSUFFICIENT_DATA',
}
